import { Stack } from "@mantine/core"

import { AGECResponses } from "@tfg/types/endpoints/agec"
import { ecoscoreAlignCSSVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

import { EcoScoreSVG } from "./EcoLabel/EcoScoreSVG"

type EcoScoreProps = {
  agecData: AGECResponses.GenericAgecData
}

export const EcoScore = ({ agecData }: EcoScoreProps) => {
  if (!agecData.ecoScoreData) {
    return null
  }
  const cost = agecData.ecoScoreData.ecoScoreCost
  const costPer100g = agecData.ecoScoreData.ecoScoreCostPer100g

  if (!cost) {
    return null
  }

  return (
    <Stack
      align={DesignStudioParametersToolkit.getCssVariableLiteralName(
        ecoscoreAlignCSSVariable
      )}
      justify="center"
      w="100%"
    >
      <EcoScoreSVG cost={cost} costPer100g={costPer100g} />
    </Stack>
  )
}
